<template>
  <div class="card">
    <div class="card-header">
      <strong>Metabase Report</strong>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <h4>Usage Instructions</h4>
        </div>
        <div class="col-md-12">
          <div class="my-3">
            <div> <b>1.</b> Select an existing template or start from scratch. </div>
            <div> <b>2.</b> Enter Filter values as per requirements </div>
            <div> <b>3.</b> If you wish to get an export output -> Click on Export Options to select more fields in export output. </div>
            <div> <b>4.</b> Click on export to generate an Excel output. </div>
            <div> <b>5.</b> If you selected an existing template and wish to save it with above filter changes, click on the button <b>"Edit and Save Template"</b>
              <div class="ml-5">OR</div>
              <div class="ml-3">If you wish to save the above filter values as a new template click on the button <b>"Save as New Template"</b> and enter a name to it.</div>
             </div>
          </div>
          <div class="py-3">Using Date filter is staright forward now:</div>

          <div class="row">
            <div class="col-md-6 pl-5">
              <b>Option 1: For Single or Multiple Dates</b>
              <ul>
                <li>Select Multiple Radio Button</li>
                <li>Click on + button to add more than a single date</li>
              </ul>
            </div>
            <div class="col-md-6">
              <b>Option 2: Range of Dates</b>
              <ul>
                <li>Select from and to</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb15" v-for="(acc, index) in accordians" :key="index+acc.title">
        <div
          class="col-md-12 Expander__trigger"
          @click="setAccordian(acc)"
          :class="(acc.isOpen)? 'active' : 'beforeBorder' "
        >
          <strong>{{acc.name}}</strong>
          <svg
            class="Expander__trigger-Icon pull-right"
            :class="{open: (acc.isOpen)}"
            width="40"
            height="12"
            stroke="cornflowerblue"
          >
            <polyline points="12,2 20,10 28,2" stroke-width="3" fill="none" />
          </svg>
        </div>

        <div class="col-md-12 acc-content Expander__body" v-show="acc.isOpen">
          <div class="subContainer">
            <div v-if="acc.title==='search'">
              <div class="row mt10 mb15">
                <div class="col-md-6">
                  <!-- <button class="btn btn-primary" @click="showAllTemplates()">Select Template</button> -->
                  <div class="form-group">
                    <v-select
                      :options="allTemplates"
                      :placeholder="'Select Template'"
                      :label="'name'"
                      :value="selectedTemplate"
                      v-model="selectedTemplate"
                      @input="editTemplate()"
                    ></v-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <!-- <h4>{{(editedTemplate && editedTemplate.name)? editedTemplate.name: ''}}</h4> -->
                </div>
              </div>
              <div class="row mt15" v-if="filterFields && filterFields.length>0">
                <div class="col-md-6">
                  <!-- <select class="form-control" v-model="selFilter['sector_name']">
                    <option value>Select Sector</option>
                    <option v-for="(sector, ind) in sectorList" :key="ind">{{sector}}</option>
                  </select>-->

                  <v-select
                    :options="sectorList"
                    :placeholder="'Select Sector'"
                    v-model="selFilter['sector_name']"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :label="'sector'"
                    track-by="title"
                    :preselect-first="true"
                    select-label
                    selectedLabel
                    deselectLabel
                  ></v-select>
                </div>
                <div class="col-md-3">
                  <label>Type of Date from:</label>
                </div>
                <div class="col-md-3">
                  <input
                    type="radio"
                    id="multiple"
                    value="Multiple"
                    v-model="dateFromType"
                    @change="dateTypeChange($event)"
                  />
                  <label for="multiple">Multiple</label>
                  <i
                    class="fa fa-plus p-2 mr-2 pointer"
                    title="Add Date from"
                    @click="addFDate"
                    v-if="dateFromType === 'Multiple'"
                  ></i>
                  <input
                    type="radio"
                    id="range"
                    value="Range"
                    v-model="dateFromType"
                    @change="dateTypeChange($event)"
                  />
                  <label for="range">Range</label>
                </div>
              </div>
              <!-- <div class="row mt10">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-5">
                      <input type="radio" id="multiple" value="Multiple" v-model="dateFromType">
                      <label for="multiple">Multiple</label>
                      <input type="radio" id="range" value="Range" v-model="dateFromType">
                      <label for="range">Range</label>
                    </div>
                    <div class="col-md-1" v-if="dateFromType === 'Multiple'" style="padding:0px">
                      <i class="fa fa-plus"></i>
                    </div>
                  </div>
                </div>
              </div>-->
              <div class="row mt-4">
                <template class="w-100" v-if="dateFromType === 'Multiple'">
                  <div class="col-md-3" :key="ind+item" v-for="(item, ind) in dateFromArr">
                    <div class="form-group w-100 d-flex">
                      <!-- <label class="form-control-label">{{filterValid[filter.stored_value]['from']}}</label> -->
                      <datepicker
                        format="DD-MM-YYYY"
                        :input-class="'form-control'"
                        ref="fdate"
                        lang="en"
                        v-model="item.date"
                        @input="getFDate($event)"
                        @clear="clearFDate()"
                        :placeholder="'Select Date'"
                      ></datepicker>
                      <!-- <div
                          class="error"
                          v-if="!filterValid[filter.stored_value]['from']"
                      >Enter valid data</div>-->
                      <span class="mt-1" v-if="dateFromArr.length > 1">
                        <i 
                          class="fa fa-trash p-2 mr-2 pointer"
                          title="Remove Date"
                          @click="removeMultipleDate(ind)"
                        ></i>
                      </span>
                    </div>
                  </div>
                </template>

                <div class="col-md-6" v-if="dateFromType === 'Range'">
                  <div class="form-group w-100">
                    <!-- <label class="form-control-label">{{filterValid[filter.stored_value]['from']}}</label> -->
                    <datepicker
                      range
                      format="DD-MM-YYYY"
                      :input-class="'form-control'"
                      ref="fdate"
                      lang="en"
                      v-model="dateFrom"
                      @input="getFDate($event)"
                      @clear="clearFDate()"
                      :placeholder="'Select Date Range'"
                    ></datepicker>
                    <!-- <div
                          class="error"
                          v-if="!filterValid[filter.stored_value]['from']"
                    >Enter valid data</div>-->
                  </div>
                </div>
              </div>
              <div class="row mt15" v-if="filterFields && filterFields.length>0">
                <div
                  class="col-md-6"
                  v-for="(filter, ind) in getFilterFields"
                  :key="ind+filter.stored_value"
                >
                  <div class="row" v-if="filter.stored_value != 'date'">
                    <div class="col-md-6">
                      <div class="form-group">
                        <!-- <label class="form-control-label">{{filterValid[filter.stored_value]['from']}}</label> -->
                        <input
                          type="text"
                          :placeholder="filter.display_name+' from'"
                          v-model="selFilter[filter.stored_value]['from']"
                          @blur="isValid(filter.stored_value, 'from')"
                          class="form-control"
                        />
                        <!-- <div
                          class="error"
                          v-if="!filterValid[filter.stored_value]['from']"
                        >Enter valid data</div>-->
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <!-- <label class="form-control-label">{{filter.display_name}} To</label> -->
                        <input
                          type="text"
                          :placeholder="filter.display_name+' to'"
                          v-model="selFilter[filter.stored_value]['to']"
                          @blur="isValid(filter.stored_value, 'to')"
                          class="form-control"
                        />
                        <!-- <div
                          class="error"
                          v-if="!filterValid[filter.stored_value]['to']"
                        >Enter valid data</div>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt15 mb15">
                <div class="col-md-12">
                  <button class="btn btn-info" @click="accordians[1].isOpen = !accordians[1].isOpen">
                    <i class="mr-2 fa " :class="[!accordians[1].isOpen ? 'fa-expand' : 'fa-compress']"></i>{{ accordians[1].isOpen ? 'Close' : 'Open' }} Export Options Tab
                  </button>
                  <button class="btn btn-success" @click="getFilteredData()">
                    <i class="fa fa-search"></i> Filter
                  </button>
                  <button class="btn btn-success" @click="exportData()">
                    <i class="fa fa-file-excel-o"></i> Export
                  </button>
                  <button class="btn btn-success" @click="showAddTemplate()">
                    <i class="fa fa-plus"></i> Create New Template
                  </button>
                  <button class="btn btn-success" @click="saveTemplate()">
                    <i class="fa fa-save"></i> Edit & Save Template
                  </button>
                </div>
              </div>
            </div>
            <div v-if="acc.title==='export'">
              <div class="row mt10 mb15">
                <div class="col-md-6">
                  <!-- <select class="form-control" v-model="selectedYears" multiple>
                    <option value>Select Years</option>
                    <option v-for="(year, ind) in years" :key="ind">{{year}}</option>
                  </select>-->
                  <v-select
                    :options="yearsList"
                    :placeholder="'Select years'"
                    v-model="selectedYears"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :label="'year'"
                    track-by="title"
                    :preselect-first="true"
                    select-label
                    selectedLabel
                    deselectLabel
                  ></v-select>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="searchExportText"
                      placeholder="Search Field"
                      @keyup="searchExportField($event)"
                    />
                  </div>
                </div>
              </div>
              <div class="row mb15" v-if="exportFields && exportFields.length>0">
                <div
                  class="col-md-4 mb10"
                  v-for="(exportField, ind) in exportFields"
                  :key="ind+exportField"
                >
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group">
                        <div class="checkbox">
                          <label :for="'checkbox'+ind" class="form-check-label w-100">
                            <input
                              type="checkbox"
                              :id="'checkbox'+ind"
                              v-model="selExportField[exportField]['toShow']"
                              class="form-check-input"
                              @change="changeSortOrder(exportField, 1)"
                            />
                            {{exportField}}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <input
                        class="form-control"
                        placeholder="sort"
                        v-model="selExportField[exportField]['sortOrder']"
                        @change="changeSortOrder(exportField, 2)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row mt15 mb15">
                <div class="col-md-12">
                  <button class="btn btn-success" @click="exportData()">
                    <i class="fa fa-file-excel-o"></i> Export
                  </button>
                  <button class="btn btn-success" @click="showAddTemplate()">
                    <i class="fa fa-plus"></i> Create Template
                  </button>
                  <button class="btn btn-success" @click="saveTemplate()">
                    <i class="fa fa-save"></i> Save Template
                  </button>
                </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="row mt15 mb15" v-if="searchData.length>0">
        <div class="col-md-9"></div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search company"
              @keyup="filteredList($event)"
            />
          </div>
        </div>
      </div>
      <div class="row mb15">
        <div class="table-responsive mt15 mb-15 app" v-dragscroll="true">
          <table
            id="report"
            class="table table-bordered app-inner"
            style="font-size: 11px;"
            v-if="rawData && rawData.length"
          >
            <thead v-if="tableFields.length>0">
              <tr>
                <th>Sr.</th>
                <th
                  @click="sortColumn(field, index)"
                  style="font-size:.92em"
                  class="data-cell column-sort"
                  v-for="(field, index, key) in tableFields"
                  v-bind:key="'field'+field+index+key"
                >
                  {{field.name}}
                  <!-- <span v-if="field.isSortable">
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort_order == 1 || field.sort_order == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                  ></i>
                  </span>-->
                </th>
              </tr>
            </thead>
            <tbody v-if="tableFields.length>0">
              <tr v-for="(row, index, key) in rawData" v-bind:key="'row'+row+index">
                <td>{{(index+1)}}</td>
                <td v-for="(field, ind) in tableFields" v-bind:key="ind+'-td-'+index+key">
                  <span
                    v-if="field.title === 'q1_a_b_greater' || field.title === 'p11_quarterly_trends' || field.title === 'sector_name' || field.title === 'co_code' || field.title === 'name' || field.title === 'market_capitalization'"
                  >
                    <span v-if="field.isLink">
                      <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                    </span>
                    <span
                      v-else
                    >{{(field.type === 'number')? getChecknFixed(row[field.title]): row[field.title]}}</span>
                  </span>
                  <span
                    v-else
                  >{{(field.type === 'number')? getChecknFixed(row[field.title]): row[field.title]}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            v-if="rawData && rawData.length==0"
            class="alert alert-danger"
            role="alert"
          >No data found!</div>
        </div>
      </div>
      <!-- <metabaseTemplates
        :show.sync="show"
        ref="smallModal"
        v-bind:large="true"
        :cancelClass="'btn btn-secondary'"
        :templatesList="allTemplates"
        @selectedTemplate="editTemplate($event)"
        :cancel="closeTemplateModal"
      ></metabaseTemplates>-->
      <metabaseAddTemplate
        :show.sync="showAddTemp"
        ref="addtemp"
        v-bind:small="true"
        :cancelClass="'btn btn-secondary'"
        @saveTemplateName="createTemplate($event)"
        :cancel="closeTemplateModal"
      ></metabaseAddTemplate>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import metabaseTemplates from "@/components/templates.vue";
import metabaseAddTemplate from "@/components/addTemplate.vue";
//import Datepicker from "vuejs-datepicker";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

export default {
  components: {
    datepicker: DatePicker,
    metabaseTemplates,
    metabaseAddTemplate,
  },
  mixins: [commonMixins, pCommonMixins],
  created() {
    this.getAllFields();
  },
  data() {
    return {
      open: false,
      accordians: [
        { title: "search", name: "Search Templates", isOpen: true },
        { title: "export", name: "Export Options", isOpen: false },
      ],
      selRowInd: 0,
      allFields: [],
      filterFields: [],
      exportFields: [],
      sectorList: [],
      years: [],
      yearsList: [],
      searchExportFields: [],
      defaultFields: [],
      sectorname: [],
      selectedYears: [],
      selFilter: {},
      filterValid: {},
      selExportField: {},
      tableFields: [],
      rawData: {},
      searchData: [],
      searchText: "",
      searchExportText: "",
      show: false,
      allTemplates: [],
      showAddTemp: false,
      selectedTemplate: "",
      selectedTemplateName: "",
      editedTemplate: null,
      // displayDate: null,
      dateTo: null,
      dateFrom: null,
      dateFromArr: [{ date: "" }],
      dateFromType: "Multiple",
    };
  },
  methods: {
    removeMultipleDate(index) {
      console.log('removeMultipleDate index', index);
      this.dateFromArr.splice(index, 1);
    },
    dateTypeChange(event) {
      if (event.target.value == "Range") {
        this.dateFromArr = [];
      } else {
        this.dateFromArr = [{ date: "" }];
      }
      console.log("dateTypeChange event", event);
    },
    setAccordian(acc) {
      acc.isOpen = !acc.isOpen;
    },
    getAllFields() {
      let myself = this;
      http.get("report/fields", {}, function (error, response) {
        console.log(error, response);
        if (!error) {
          myself.allFields = response;
          myself.filterFields = response.filter_fields;
          myself.sectorList = response.sectors;
          myself.years = response.years;
          myself.exportFields = response.export_fields;
          myself.searchExportFields = myself.exportFields;
          myself.showAllTemplates();
          myself.setFilters();
          myself.setExportFields();
          // myself.addSector();
          myself.getYears();
        }
      });
    },
    setFilters() {
      this.filterFields.forEach((val, key) => {
        // console.log(val, this);
        this.filterFields[key]["type"] =
          val.stored_value === "sector_name" ? "string" : "number";
        if (val.stored_value !== "sector_name" && val.stored_value !== "date") {
          this.selFilter[val.stored_value] = { from: "", to: "" };
          this.selFilter[val.stored_value]["from"] = "";
          this.selFilter[val.stored_value]["to"] = "";
          this.filterValid[val.stored_value] = { from: true, to: true };
          this.filterValid[val.stored_value]["from"] = true;
          this.filterValid[val.stored_value]["to"] = true;
        } else if (val.stored_value == "date") {
          this.selFilter[val.stored_value] = { from: "", to: "" };
          this.selFilter[val.stored_value]["from"] = "";
          this.selFilter[val.stored_value]["to"] = "";
          this.filterValid[val.stored_value] = { from: true, to: true };
          this.filterValid[val.stored_value]["from"] = true;
          this.filterValid[val.stored_value]["to"] = true;
        } else {
          this.selFilter[val.stored_value] = "";
        }
      });
      console.log(this.filterFields, this.selFilter);
    },
    setExportFields() {
      this.exportFields.forEach((val, key) => {
        this.selExportField = !this.selExportField ? {} : this.selExportField;
        this.selExportField[val] = { toShow: false, sortOrder: "" };
      });
      console.log(this.selExportField);
    },
    setEditFilters(data) {
      console.log(data);
      Object.keys(data).forEach((val, key) => {
        if (key !== "sector_name") {
          this.selFilter[val] = data[val];
          this.filterValid[val] = data[val];
        } else {
          this.selFilter[val] = "";
        }
      });
      console.log(this.filterFields, this.selFilter);
    },
    setEditExportFields(data) {
      Object.keys(data).forEach((val, key) => {
        this.selExportField = !this.selExportField ? {} : this.selExportField;
        this.selExportField[val] = data[val];
      });
      console.log(this.selExportField);
    },
    searchExportField(e) {
      if (this.searchExportText.length > 2 || e.keyCode === 13) {
        this.exportFields = this.searchExportFields.filter((field) => {
          console.log("export field", field);
          return field
            .toLowerCase()
            .includes(this.searchExportText.toLowerCase());
        });
      }
      if (
        this.searchExportText === null ||
        this.searchExportText === "" ||
        this.searchExportText.length <= 2
      ) {
        this.exportFields = this.searchExportFields;
        return this.exportFields;
      }
    },
    getFilteredData() {
      console.log(
        this.editedTemplate !== null,
        this.checkIfChangesMade(this.selFilter, 1)
      );
      console.log("dateFromArray", this.dateFromArr);
      console.log("dateFrom", this.dateFrom);
      console.log("dateFromType", this.dateFromType);
      if (
        // this.editedTemplate !== null ||
        // this.checkIfChangesMade(this.selFilter, 1)
        true
      ) {
        const myself = this;
        // if(myself.selFilter['date'] && myself.selFilter['date']['from'] !=''){
        //   var dateFrom_array = myself.dateFromArr
        //   var dateFrom_array_new = []
        //   for(let i=0; i<dateFrom_array.length; i++) {
        //     dateFrom_array_new.push(myself.getYMDDate(dateFrom_array[i].date))
        //   }
        //   myself.selFilter['date']['from'] = dateFrom_array_new;
        // }
        // if(myself.selFilter['date'] && myself.selFilter['date']['to'] !=''){
        //   myself.selFilter['date']['to'] = myself.getYMDDate(myself.selFilter['date']['to']);
        // }
        if (this.dateFromType == "Range") {
          myself.selFilter["date"]["from"] = myself.getYMDDate(
            myself.dateFrom[0]
          );
          myself.selFilter["date"]["to"] = myself.getYMDDate(
            myself.dateFrom[1]
          );
        } else {
          const dateFrom_array = myself.dateFromArr;
          const dateFrom_array_new = [];
          for (let i = 0; i < dateFrom_array.length; i++) {
            if (dateFrom_array[i].date != "") {
              dateFrom_array_new.push(
                myself.getYMDDate(dateFrom_array[i].date)
              );
            }
          }
          myself.selFilter["date"]["from"] = dateFrom_array_new;
          myself.selFilter["date"]["to"] = "";
        }
        let data = {};
        if (this.editedTemplate !== null) {
          myself.editedTemplate.filters = myself.selFilter;
          data = myself.editedTemplate;
        } else {
          data = { name: "", filters: myself.selFilter };
        }
        console.log(myself.selFilter); //{filters: this.selFilter}
        http.post("report", data, function (error, response) {
          console.log("Response", response);
          if (!error) {
            if (response.responseType === "success") {
              myself.rawData = response.data;
              myself.searchData = response.data;
              if (myself.rawData.length) {
                const tableFields = [];
                const fields = Object.keys(myself.rawData[0]);
                fields.forEach((val, key) => {
                  tableFields.push({
                    title: val,
                    name: myself.getCustomLabel(val)
                      ? myself.getCustomLabel(val)
                      : myself.getLabel(val),
                    isLink: val === "companyname" ? 1 : 0,
                    sort_order:
                      val === "co_code"
                        ? 1
                        : val === "companyname"
                        ? 2
                        : val === "sectorname"
                        ? 3
                        : val === "market_capitalization"
                        ? 4
                        : 7,
                    type:
                      val === "co_code" ||
                      val === "companyname" ||
                      val === "sectorname"
                        ? "string"
                        : "number",
                  });
                });
                myself.tableFields = myself.sorted_fields_asc(
                  tableFields,
                  "sort_order"
                );
              }
              myself.accordians[0].isOpen = false;
              myself.accordians[1].isOpen = false;
              console.log(myself.tableFields, myself.rawData);
            } else {
              console.log("No data");
              myself.clearData();
            }
          }
        });
      } else {
        this.$toastr.error(
          "Please select any template or filter to search data",
          {},
          ""
        );
      }
    },
    exportData() {
      console.log(
        this.selectedYears,
        this.editedTemplate,
        this.selFilter,
        this.selExportField
      );
      console.log('this.editedTemplate', this.editedTemplate);
      // return;
      console.log(
        this.checkIfChangesMade(this.selFilter, 1),
        this.checkIfChangesMade(this.selExportField, 2)
      );
      if (
        // this.editedTemplate !== null ||
        // this.checkIfChangesMade(this.selFilter, 1) ||
        // this.checkIfChangesMade(this.selExportField, 2)
        true
      ) {
        // this.addSector();
        const myself = this;
        console.log(myself.selFilter);
        const name =
          this.editedTemplate !== null ? myself.editedTemplate.name : "";
        // if(myself.selFilter['date'] && myself.selFilter['date']['from'] !=''){
        //   myself.selFilter['date']['from'] = myself.getYMDDate(myself.selFilter['date']['from']);
        // }
        // if(myself.selFilter['date'] && myself.selFilter['date']['to'] !=''){
        //     myself.selFilter['date']['to'] = myself.getYMDDate(myself.selFilter['date']['to']);
        // }
        if (this.dateFromType == "Range") {
          myself.selFilter["date"]["from"] = myself.getYMDDate(
            myself.dateFrom[0]
          );
          myself.selFilter["date"]["to"] = myself.getYMDDate(
            myself.dateFrom[1]
          );
        } else {
          const dateFrom_array = myself.dateFromArr;
          const dateFrom_array_new = [];
          for (let i = 0; i < dateFrom_array.length; i++) {
            if (dateFrom_array[i].date != "") {
              dateFrom_array_new.push(
                myself.getYMDDate(dateFrom_array[i].date)
              );
            }
          }
          myself.selFilter["date"]["from"] = dateFrom_array_new;
          myself.selFilter["date"]["to"] = "";
        }
        const data = {
          name: name,
          filters: myself.selFilter,
          exportFields: myself.selExportField,
          years: myself.selectedYears,
        };
        // console.log(JSON.stringify(data));
        http.post("report?export=true", data, function (error, response) {
          console.log("Response", response);
          if (!error) {
            if (response.responseType === "success") {
              window.open(response.download_link, "_blank");
            }
          }
        });
      } else {
        this.$toastr.error(
          "Please select any one template or filters to export data",
          {},
          ""
        );
      }
    },
    showAddTemplate() {
      this.$refs.addtemp.open();
    },
    createTemplate(val) {
      console.log("Template Name", val);
      console.log(this.selFilter, this.selExportField);
      if (
        // this.checkIfChangesMade(this.selFilter, 1) ||
        // this.checkIfChangesMade(this.selExportField, 2)
        true
      ) {
        // if (this.selFilter["date"] && this.selFilter["date"]["from"] != "") {
        //   this.selFilter["date"]["from"] = this.getYMDDate(
        //     this.selFilter["date"]["from"]
        //   );
        // }
        // if (this.selFilter["date"] && this.selFilter["date"]["to"] != "") {
        //   this.selFilter["date"]["to"] = this.getYMDDate(
        //     this.selFilter["date"]["to"]
        //   );
        // }
        if (this.dateFromType == "Range") {
          this.selFilter["date"]["from"] = this.getYMDDate(
            this.dateFrom[0]
          );
          this.selFilter["date"]["to"] = this.getYMDDate(
            this.dateFrom[1]
          );
        } else {
          const dateFrom_array = this.dateFromArr;
          const dateFrom_array_new = [];
          for (let i = 0; i < dateFrom_array.length; i++) {
            if (dateFrom_array[i].date != "") {
              dateFrom_array_new.push(
                this.getYMDDate(dateFrom_array[i].date)
              );
            }
          }
          this.selFilter["date"]["from"] = dateFrom_array_new;
          this.selFilter["date"]["to"] = "";
        }
        const data = {
          name: val,
          filters: this.selFilter,
          exportFields: this.selExportField,
          years: this.selectedYears,
        };
        console.log(data);
        const myself = this;
        http.post("report/templates", data, function (error, response) {
          console.log(response, error);
          if (!error) {
            if (response && response.responseType === "success") {
              myself.$toastr.success(response.msg, {}, "");
              myself.showAllTemplates();
            } else {
              myself.$toastr.error(response.msg, {}, "");
            }
          }
        });
      } else {
        this.$toastr.error(
          "Please select filters or fields to create template",
          {},
          ""
        );
      }
    },
    saveTemplate() {
      if (this.editedTemplate !== null) {
        // if (this.selFilter["date"] && this.selFilter["date"]["from"] != "") {
        //   this.selFilter["date"]["from"] = this.getYMDDate(
        //     this.selFilter["date"]["from"]
        //   );
        // }
        // if (this.selFilter["date"] && this.selFilter["date"]["to"] != "") {
        //   this.selFilter["date"]["to"] = this.getYMDDate(
        //     this.selFilter["date"]["to"]
        //   );
        // }
        if (this.dateFromType == "Range") {
          this.selFilter["date"]["from"] = this.getYMDDate(
            this.dateFrom[0]
          );
          this.selFilter["date"]["to"] = this.getYMDDate(
            this.dateFrom[1]
          );
        } else {
          const dateFrom_array = this.dateFromArr;
          const dateFrom_array_new = [];
          for (let i = 0; i < dateFrom_array.length; i++) {
            if (dateFrom_array[i].date != "") {
              dateFrom_array_new.push(
                this.getYMDDate(dateFrom_array[i].date)
              );
            }
          }
          this.selFilter["date"]["from"] = dateFrom_array_new;
          this.selFilter["date"]["to"] = "";
        }
        // this.addSector();
        const data = {
          name: this.editedTemplate.name,
          filters: this.selFilter,
          years: this.selectedYears,
          exportFields: this.selExportField,
          _id: this.editedTemplate._id,
        };
        console.log(data);
        const myself = this;
        http.post(
          "report/templates/" + myself.editedTemplate._id,
          data,
          function (error, response) {
            console.log(response, error);
            if (!error) {
              if (response && response.responseType === "success") {
                myself.$toastr.success(response.msg, {}, "");
                myself.showAllTemplates();
              } else {
                myself.$toastr.error(response.msg, {}, "");
              }
            }
          }
        );
      } else {
        this.$toastr.error("Please select template to save");
      }
    },
    editTemplate() {
      const val = this.selectedTemplate;
      this.rawData = {};
      console.log(val);
      if (val !== null && val !== "") {
        let myself = this;
        // myself.editedTemplate = val;
        // myself.selFilter = val.filters ? val.filters : {};
        // myself.selExportField = val.exportFields ? val.exportFields : {};
        // myself.selectedYears = val.years ? val.years : [];
        console.log(
          myself.selFilter,
          myself.selExportField,
          myself.selectedYears
        );
        // myself.sectorname = val.filters.sector_name;
        myself.clearData();
        http.get("report/templates/" + val._id, {}, function (error, response) {
          if (!error) {
            console.log("EDIT", response);
            if (response) {
              if(response.filters.date.to == '') {
                myself.dateFromType = 'Multiple';
                if(response.filters.date.from) {
                  const multipleDates = response.filters.date.from.map(item =>{ return {date: new Date(item)}});
                  myself.dateFromArr = multipleDates;
                  console.log('after multipleDates', multipleDates);
                  console.log('dateFromArr', myself.dateFromArr);
                }
              } else {
                myself.dateFromType = 'Range';
                console.log('before dateFrom', myself.dateFrom);
                if(response.filters.date.from && response.filters.date.to) {
                  const fromToArr = [new Date(response.filters.date.from), new Date(response.filters.date.to)];
                  myself.dateFrom = fromToArr;
                  console.log('fromToArr', fromToArr);
                  console.log('myself.dateFrom', myself.dateFrom);
                }               
              }
              myself.editedTemplate = response;
              myself.setEditFilters(response.filters);
              myself.setEditExportFields(response.exportFields);
              // myself.selFilter = response.filters ? response.filters : {};
              // myself.selExportField = response.exportFields ? response.exportFields : {};
              myself.selectedYears = response.years ? response.years : [];
              myself.clearData();
              console.log(
                "EDITED FILTERS",
                myself.selFilter,
                myself.selectedYears,
                myself.selExportField
              );
            } else myself.$toastr.error("Template does not exists", {}, "");
          } else myself.$toastr.error("Oops, something went wrong. Try again later.", {}, "");
        });
      } else {
        this.selectedYears = [];
        this.setFilters();
        this.setExportFields();
        this.editedTemplate = null;
        this.selectedTemplate = "";
      }
    },
    closeTemplateModal() {
      console.log("Closed");
    },
    changeSortOrder(field, type) {
      console.log(
        field,
        this.selExportField[field].toShow,
        this.selExportField[field].sortOrder,
        this.selExportField[field].sortOrder !== "",
        this.selExportField[field].sortOrder === ""
      );
      if (type === 2) {
        if (this.selExportField[field].sortOrder !== "") {
          this.selExportField[field].toShow = true;
        }
      } else if (type === 1) {
        if (!this.selExportField[field].toShow) {
          this.selExportField[field].sortOrder = "";
        }
      }
      console.log(
        field,
        this.selExportField[field].toShow,
        this.selExportField[field].sortOrder
      );
    },
    filteredList(e) {
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter((rd) => {
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.companyname
              ? rd.companyname
                  .toLowerCase()
                  .includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    clearData() {
      this.rawData = {};
      this.searchData = [];
      this.tableFields = [];
    },
    // addSector() {
    //   if (this.sectorname !== "") {
    //     this.selFilter["sector_name"] = this.sectorname;
    //   } else {
    //     this.selFilter["sector_name"] = "";
    //   }
    // },
    getFDate(e) {
      for (let i = 0; i < e.length; i++) {
        if (
          this.selFilter["date"]["to"] != "" &&
          new Date(e[i]) > this.selFilter["date"]["to"]
        ) {
          this.$toastr.error("From date must be smaller than To date");
          this.selFilter["date"]["from"] = "";
          this.dateFrom = null;
          console.log("From", this.selFilter["date"]["from"]);
          break;
        }
      }
      // let _this = this
      // _this.displayDate = ''
      // let date_array = []
      // e.forEach(obj=>{
      //   let formattedDate = moment(obj).format('DD-MM-YYYY');
      //   date_array.push(formattedDate)
      // })
      // _this.displayDate = date_array.map(function(obj){return obj}).join(', ')
    },
    addFDate() {
      this.dateFrom = "";
      this.dateFromArr.push({ date: "" });
    },
    getToDate(e) {
      this.selFilter["date"]["to"] = e;
      var dateFrom_array = this.dateFrom;
      for (let i = 0; i < dateFrom_array.length; i++) {
        if (new Date(e) < dateFrom_array[i]) {
          this.$toastr.error("To date must be greater than From date");
          this.selFilter["date"]["to"] = "";
          this.dateTo = null;
          console.log("To", this.selFilter["date"]["to"]);
          break;
        }
      }
    },
    clearFDate() {
      console.log(this.selFilter["date"]["from"]);
      this.selFilter["date"]["from"] = "";
      this.dateFrom = null;
    },
    clearTDate() {
      console.log(this.selFilter["date"]["to"]);
      this.selFilter["date"]["to"] = "";
      this.dateTo = null;
    },
    getYears() {
      const years = this.years;
      years.forEach((val) => {
        console.log(val);
        this.yearsList.push("" + val + "");
      });
      console.log(this.yearsList);
    },
    getSelectedYears() {
      let selectedYears = [];
      this.selectedYears.forEach((val) => {
        selectedYears.push(val.year);
      });
      return selectedYears;
    },
    checkIfChangesMade(data, type) {
      let isChanged = false;
      if (type === 1) {
        this.filterFields.forEach((val, key) => {
          if (val.stored_value !== "sector_name") {
            if (
              this.selFilter[val.stored_value]["from"] !== "" &&
              this.selFilter[val.stored_value]["to"] !== ""
            ) {
              isChanged = true;
              return;
            }
          } else {
            if (this.selFilter[val.stored_value] !== "") {
              isChanged = true;
              return;
            }
          }
        });
      } else if (type === 2) {
        this.exportFields.forEach((val, key) => {
          if (
            this.selExportField[val]["toShow"] &&
            this.selExportField[val]["sortOrder"] !== ""
          ) {
            isChanged = true;
            return;
          }
        });
      }
      return isChanged;
    },
    isValid(val, type) {
      const value = this.selFilter[val][type];
      if (value !== "" && !value.match(/^[+-]?((\.\d+)|(\d+(\.\d+)?))$/)) {
        console.log("Not valid");
        this.filterValid[val][type] = !this.filterValid[val][type];
        this.selFilter[val][type] = "";
      } else {
        // this.filterValid[val][type] = true;
      }
      console.log(this.filterValid);
    },
    showAllTemplates() {
      var myself = this;
      http.get("report/templates", {}, function (error, response) {
        if (!error) {
          if (response && response.length) {
            myself.allTemplates = response;
            // myself.$refs.smallModal.open();
          } else myself.$toastr.success("No template added", {}, "");
        } else myself.$toastr.error("Oops, something went wrong. Try again later.", {}, "");
      });
    },
  },
  watch: {},
  computed: {
    getFilterFields() {
      return this.filterFields.filter(function (row, index) {
        return row.type === "number";
      });
    },
  },
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
.modal {
  display: block;
}

.modal-dialog,
.modal-backdrop {
  transition: all 0.5s ease;
}

.modal-enter .modal-dialog,
.modal-leave-active .modal-dialog {
  opacity: 0;
  transform: translateY(-30%);
}

.modal-enter .modal-backdrop,
.modal-leave-active .modal-backdrop {
  opacity: 0;
}

.modal-backdrop {
  opacity: 0.5;
}

/* Modal styles */

.modal-header {
  height: auto;
  padding: 0 1.6rem;
  border-bottom: 2px solid #eee;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}

.modal-content {
  border-radius: 0;
}

.modal-footer {
  justify-content: center;
  padding: 0 2px;
  padding-bottom: 5px;
  flex-wrap: wrap;
}
.btn {
  margin: 0 10px 20px 10px;
}
span.vdp-datepicker__clear-button {
  float: right !important;
  font-size: 20px;
  position: relative;
  top: -35px;
  right: 10px;
}
.mx-icon-calendar {
  display: none;
}
.mx-datepicker {
  width: inherit;
}

.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/metabase/reports.vue